<template>
    <div>
      <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
      <b-card>
        <div style="position: relative">
          <b-row class="justify-content-between align-items-center">
            <b-col class="d-flex align-items-center">
              <h3>طلبات المنحة المالية</h3>
            </b-col>
            <b-col cols="3">
              <search-input
                placeholder="البحث بحسب اسم المنظمة"
                v-model="searchKey.ngo_name"
              />
            </b-col>
            <b-col md="3">
              <search-input
                placeholder="البحث بحسب الحساب المصرفي"
                v-model="searchKey.bank_account_number"
              />
            </b-col>
          </b-row>
          <hr />
          <data-table
            id="ngos-table"
            :ep.sync="ep"
            :fields="fields"
            ref="requestesTable"
            exporFromFrontSide
          >
          <template #cell(_)="row">
                <div class="d-flex align-items-center justify-content-end">
                <b-button
                    variant="flat-info"
                    @click="row.toggleDetails"
                    title="عرض المزيد من المعلومات"
                    size="sm"
                    class="btn-icon rounded-circle"
                    v-b-tooltip.hover.v-info.top
                >
                    <feather-icon icon="InfoIcon" size="1.8x" color="#4fc98c" />
                </b-button>

                </div>
            </template>
            <template #row-details="row">
                <b-card>
                <b-row class="mb-2">
                    <b-col md="12" class="mb-1 d-flex">
                    <strong>أوجه الإنفاق المُراد توظيف الإعانة فيها :</strong>
                    <div class="text-info mx-1" v-html="row.item.expenditures"></div>
                    </b-col>
                </b-row>

                <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="row.toggleDetails"
                >
                    عرض اقل
                </b-button>
                </b-card>
            </template>
          </data-table>
        </div>
      </b-card>
    </div>
  </template>

  <script>
  import {
    BRow,
    BCol,
    BCard,
    BButton,
    BDropdown,
    BDropdownItem,
    BBadge,
    VBTooltip
  } from "bootstrap-vue";
  import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
  import DataTable from "@/components/data-table";
  import debounce from "lodash.debounce";
  import SearchInput from "@/components/SearchInput.vue";
  import formAutocomplete from "@/components/form-autocomplete";
  import Ripple from "vue-ripple-directive";
  export default {
    components: {
      BBadge,
      formAutocomplete,
      SearchInput,
      BRow,
      BCol,
      BCard,
      BButton,
      BDropdown,
      BDropdownItem,
      MinistryBreadcrumbs,
      DataTable,
    },

    directives: {
        "b-tooltip": VBTooltip,
        Ripple,
    },
    data() {
      return {
        mainTitle: " المعاملات",

        type: "ADD",
        searchKey: {},
        ep: "v2/ministry/financial-grants",

        fields: [
          { label: "المعرف", key: "id" },
          { label: "اسم المنظمة", key: "ngo.name_ar" },
          { label: "الحساب المصرفي", key: "ngoBankAccount.account_no" },
          "_",
        ],
        breadcrumbs: [
          {

            text: "إدارة المنظمات",
            to: "/ministry/ngos-communication",
          },
          {
            text: "طلبات المنحة المالية",
            active: true,
          },
        ],
      };
    },

    watch: {
      searchKey: {
        deep: true,
        handler: debounce(function (value) {
          this.$refs.requestesTable.setQueryParams(this.searchKey);
          this.$refs.requestesTable.refreshTable();
        }, 300),
      },
    },
  };
  </script>
